<script setup></script>
<template>
  <div class="mgy-10 mgx-5 txt-center">
    <h1 class="txt-theme-brand-1">Security and Privacy</h1>
    <h1 class="mgy-5 txt-theme-warning-1">-> TODO &lt;-</h1>
  </div>
</template>
